import { render } from "./StatsCard.vue?vue&type=template&id=22d08142&scoped=true"
const script = {}

import "./StatsCard.vue?vue&type=style&index=0&id=22d08142&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22d08142"

export default script